import React from 'react';
import styled from 'styled-components';

const Card = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  margin-bottom: 0.25rem;
  background: #ffffff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow: hidden;
`;

const PatternContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  justify-content: center;
  padding: 0.45rem;
  background: #f8f9fa;
  border-radius: 2px;
  min-height: 3rem;
`;

const PatternItem = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  font-weight: 600;
  font-size: 0.85rem;
  transition: transform 0.2s ease;
  color: white;

  &:hover {
    transform: scale(1.1);
  }

  &.E { background-color: #3b82f6; }
  &.O { background-color: #ef4444; }
  &.R { background-color: #10b981; }
  &.F { background-color: #ef4444; }
  &.Ov { background-color: #10b981; }
  &.U { background-color: #ef4444; }

  &.digit-0 { background-color: #3b82f6; }
  &.digit-1 { background-color: #ef4444; }
  &.digit-2 { background-color: #10b981; }
  &.digit-3 { background-color: #f59e0b; }
  &.digit-4 { background-color: #8b5cf6; }
  &.digit-5 { background-color: #ec4899; }
  &.digit-6 { background-color: #14b8a6; }
  &.digit-7 { background-color: #f97316; }
  &.digit-8 { background-color: #64748b; }
  &.digit-9 { background-color: #84cc16; }

  @media (max-width: 768px) {
    width: 1.75rem;
    height: 1.75rem;
    font-size: 0.8rem;
  }

  @media (max-width: 576px) {
    width: 1.5rem;
    height: 1.5rem;
    font-size: 0.75rem;
  }
`;

interface PatternItemData {
  char: string;
  class: string;
  tooltip?: string;
}

interface PatternDisplayProps {
  pattern: PatternItemData[];
  contractType: string;
}

const PatternDisplay: React.FC<PatternDisplayProps> = ({ pattern }) => {
  // Display the last 20 patterns as received from WebSocket hook
  const displayPattern = pattern.slice(-20);

  return (
    <Card>
      <PatternContainer>
        {displayPattern.map((item, index) => (
          <PatternItem
            key={index}
            className={item.class}
            title={item.tooltip}
          >
            {item.char}
          </PatternItem>
        ))}
      </PatternContainer>
    </Card>
  );
};

export default PatternDisplay;
